import { FullMaterialSupportedComponent, MaterialComponentCategory } from 'api';
import { MaterialSupportedComponentAutocomplete, useFormContext, useWatch } from 'form';
import { Grid, IconButton } from 'ui';
import { Close } from 'ui/icons';

import { MaterialComponentValueType } from '../../schema';
import { MaterialSupportedComponentValue } from '../MaterialSupportedComponentValue/MaterialSupportedComponentValue';

type Props = {
  name: string;
  index: number;
  materialId?: number;
  materialColourId?: number;
  category?: MaterialComponentCategory;
  remove: (index: number) => void;
  disabled?: boolean;
};

export const MaterialSupportedComponent = ({
  name,
  category,
  index,
  remove,
  materialId,
  materialColourId,
  disabled,
}: Props) => {
  const form = useFormContext();

  const componentValue = useWatch({
    control: form.control,
    name: `${name}.${index}`,
  }) as MaterialComponentValueType;

  const setComponentValue = (value: MaterialComponentValueType) => {
    form.setValue(`${name}.${index}`, value);
  };

  const onMaterialSupportedComponentChange = (option: FullMaterialSupportedComponent) => {
    if (!option) {
      return;
    }
    setComponentValue({
      allowed_value_type: option.allowed_value_type,
      boolean_value: undefined,
      max_value: undefined,
      min_value: undefined,
      supported_component_id: option.id,
      unit: option.component.unit,
    });
  };

  const selectedSupportedComponentIds = useWatch({
    control: form.control,
    name: `${name}`,
  }).map((item: { supported_component_id: number }) => item.supported_component_id);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <MaterialSupportedComponentAutocomplete
          label="Material component"
          name={`${name}.${index}.supported_component_id`}
          data-testid={`${name}.${index}.supported_component_id`}
          defaultValue={componentValue.supported_component_id}
          required
          materialId={materialId}
          materialColourId={materialColourId}
          onSelectOption={onMaterialSupportedComponentChange}
          filterOptions={(options) => options.filter((option) => !selectedSupportedComponentIds.includes(option.id))}
          category={category}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={10} sm={5}>
        <MaterialSupportedComponentValue
          name={`${name}.${index}`}
          allowedValueType={componentValue?.allowed_value_type}
          unit={componentValue?.unit || undefined}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={2} sm={1}>
        <IconButton onClick={() => remove(index)} data-testid={`${name}-remove-${index}`} disabled={disabled}>
          <Close />
        </IconButton>
      </Grid>
    </Grid>
  );
};
